import "./assets/js/nav-pills.js";
import "./assets/scss/argon-dashboard.scss";

export default {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  install() {},
};
